var error = {
  translation: {
    error: {
      coreNotFound: 'Échec de la récupération des paramètres de base',
      domainNotAllowed: 'Vous ne pouvez pas vous inscrire avec une adresse email provenant de ce domaine',
      emailAlreadyInUse: 'Email déjà utilisé',
      insufficientPermissions: 'Permissions insuffisantes',
      invalidCurrentPassword: 'Mot de passe actuel invalide',
      invalidPermissions: 'Veuillez sélectionner au moins une permission',
      invalidUsernameOrPassword: "Nom d'utilisateur ou mot de passe invalide",
      localRegistrationDisabled: "L'enregistrement local de l'utilisateur est désactivé par l'administrateur",
      noInternetConnection: 'Aucune connection internet',
      noOidcProfileFound: 'Aucun profil OIDC trouvé',
      policyNotAccepted: "Veuillez accepter les conditions d'utilisation et la politique de confidentialité",
      registrationDisabled: "Toutes les inscriptions d'utilisateurs sont désactivées par l'administrateur",
      serverConnectionFailed: 'Connection au serveur échouée',
      ssoRegistrationDisabled: "L'enregistrement SSO de l'utilisateur est désactivé par l'administrateur",
      tooManyFailedAttempts: 'Trop de tentatives infructueuses - veuillez réessayer plus tard',
      unknownError: 'Erreur inconnue, réessayez plus tard',
      usernameAlreadyInUse: "Nom d'utilisateur déjà utilisé",
      weakPassword: 'Mot de passe faible',
    },
  },
};

export { error as default };
